/* ============================================
   NAOKO — Home Tiles (karuzela mobilna + kropki)
   File: assets/naoko-home-tiles.js
   ============================================ */
(function () {
  var MQ_REDUCE = '(prefers-reduced-motion: reduce)';

  function activateVideo(video) {
    if (video.dataset.tileVideoInited) return;
    video.dataset.tileVideoInited = '1';

    // Reduced motion → zostaje statyczny poster, wideo nie startuje.
    if (window.matchMedia && window.matchMedia(MQ_REDUCE).matches) return;

    var mq = video.dataset.mobileMq || '(max-width: 749px)';
    var isMobile = window.matchMedia && window.matchMedia(mq).matches;
    var src = isMobile
      ? video.dataset.srcMobile || video.dataset.srcDesktop
      : video.dataset.srcDesktop || video.dataset.srcMobile;
    if (!src) return;

    // Pobieramy DOKŁADNIE jedno źródło (desktop ALBO mobile).
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.load();

    video.addEventListener(
      'playing',
      function () {
        video.classList.add('is-ready');
      },
      { once: true }
    );

    tryPlay(video);
  }

  // ---- Start / wznowienie odtwarzania (Safari) ----
  // Safari na Macu/iPhonie odrzuca play() bez gestu (NotAllowedError), gdy użytkownik ma
  // Autoodtwarzanie „Nigdy” dla witryny albo tryb niskiego zużycia energii — mimo `muted`.
  // Diagnoza 2026-09-25: wideo w pełni pobrane (readyState 4), play() → NotAllowedError.
  // Po odrzuceniu ponawiamy przy PIERWSZYM geście użytkownika (WebKit liczy pointerdown/
  // touchend/keydown/click jako aktywację; scroll NIE). Chrome nigdy tu nie wchodzi.
  var GESTURES = ['pointerdown', 'touchend', 'keydown', 'click'];

  function tryPlay(video) {
    // Jawnie w JS, nie tylko atrybut: polityka autoplay patrzy na stan `muted` w chwili play().
    video.muted = true;
    video.defaultMuted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        armGestureRetry(video);
      });
    }
  }

  function armGestureRetry(video) {
    if (video.dataset.tileVideoGesture) return;
    video.dataset.tileVideoGesture = '1';
    var retry = function () {
      for (var i = 0; i < GESTURES.length; i++) document.removeEventListener(GESTURES[i], retry, true);
      video.dataset.tileVideoGesture = '';
      if (video.paused) tryPlay(video);
    };
    for (var i = 0; i < GESTURES.length; i++) {
      document.addEventListener(GESTURES[i], retry, { capture: true, passive: true });
    }
  }

  // Safari przywraca stronę z bfcache (powrót „wstecz”) i wraca z karty w tle ze
  // spauzowanym wideo, a poster jest już ukryty (is-ready) → zamrożony kadr. Wznawiamy.
  function resumeAll() {
    var videos = document.querySelectorAll('[data-naoko-tile-video][data-tile-video-inited="1"]');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      if (v.paused && !v.ended && v.querySelector('source')) tryPlay(v);
    }
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) resumeAll();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resumeAll();
  });

  function scheduleVideo(video) {
    // Odraczamy doładowanie wideo, by poster zdążył się namalować (LCP).
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { activateVideo(video); }, { timeout: 2500 });
    } else {
      setTimeout(function () { activateVideo(video); }, 250);
    }
  }

  function initVideos(root) {
    if (!root || !root.querySelectorAll) return;
    var videos = root.querySelectorAll('[data-naoko-tile-video]');
    for (var i = 0; i < videos.length; i++) scheduleVideo(videos[i]);
  }

  function init(root) {
    initVideos(root);

    if (!root || root.dataset.tilesInit === '1') return;
    var track = root.querySelector('.naoko-home-tiles__track');
    var dots = root.querySelector('.naoko-home-tiles__dots');
    if (!track || !dots) return;

    var tiles = Array.prototype.slice.call(track.children);
    if (tiles.length < 2) {
      dots.innerHTML = '';
      root.dataset.tilesInit = '1';
      return;
    }

    root.dataset.tilesInit = '1';
    dots.innerHTML = '';

    tiles.forEach(function (tile, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'naoko-home-tiles__dot';
      b.setAttribute('aria-label', 'Przejdź do slajdu ' + (i + 1));
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () {
        stopAutoplay();
        scrollToTile(tile);
      });
      dots.appendChild(b);
    });

    var dotEls = Array.prototype.slice.call(dots.children);
    var current = 0;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            current = tiles.indexOf(e.target);
            dotEls.forEach(function (d, di) {
              d.setAttribute('aria-current', di === current ? 'true' : 'false');
            });
          });
        },
        { root: track, threshold: 0.6 }
      );
      tiles.forEach(function (t) {
        io.observe(t);
      });
    }

    // ---- Autoodtwarzanie (tylko mobile) ----
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var reduceMotion = window.matchMedia(MQ_REDUCE).matches;
    var autoplayOn = root.dataset.autoplay === 'true';
    var startDelay = (parseFloat(root.dataset.autoplayDelay) || 0) * 1000;
    var tickEvery = (parseFloat(root.dataset.autoplayInterval) || 3) * 1000;
    var startTimer = null;
    var tickTimer = null;
    var userStopped = false;

    function clearTimers() {
      if (startTimer) {
        clearTimeout(startTimer);
        startTimer = null;
      }
      if (tickTimer) {
        clearInterval(tickTimer);
        tickTimer = null;
      }
    }

    // przewijamy WYŁĄCZNIE poziomo sam track (bez scrollIntoView, które
    // wciągałoby całą stronę do góry, gdy sekcja jest już nad ekranem)
    function scrollToTile(tile) {
      var left = track.scrollLeft + (tile.getBoundingClientRect().left - track.getBoundingClientRect().left);
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    function goNext() {
      var next = (current + 1) % tiles.length;
      scrollToTile(tiles[next]);
    }

    function startAutoplay() {
      clearTimers();
      if (userStopped || !autoplayOn || reduceMotion || !mqMobile.matches) return;
      startTimer = setTimeout(function () {
        tickTimer = setInterval(function () {
          if (!document.hidden) goNext();
        }, tickEvery);
      }, startDelay);
    }

    // pierwszy gest użytkownika (swipe/klik kropki) wyłącza autoplay na stałe
    function stopAutoplay() {
      userStopped = true;
      clearTimers();
    }

    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, stopAutoplay, { passive: true, once: true });
    });

    // resize/obrót ekranu: poza mobile stop; na mobile (re)start, o ile nie wyłączono
    if (mqMobile.addEventListener) {
      mqMobile.addEventListener('change', startAutoplay);
    } else if (mqMobile.addListener) {
      mqMobile.addListener(startAutoplay);
    }

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.naoko-home-tiles').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Theme Editor: re-init po dodaniu/przeładowaniu sekcji
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector && e.target.querySelector('.naoko-home-tiles');
    if (el) {
      el.dataset.tilesInit = '';
      init(el);
    }
  });
})();

